import i18n from '@/libs/i18n/index'
export const predefineColors = [
  '#000000',
  '#ffffff',
  '#ff4400',
  '#ff8c00',
  '#ffd700',
  '#90ee90',
  '#00ced1',
  '#1e90ff',
  '#c71585'
]

export const fontList = [
  'Alimama DaoLiTi',
  'Alibaba PuHuiTi 3.0 35 Thin',
  'Alibaba PuHuiTi 3.0 45 Light',
  'Alibaba PuHuiTi 3.0 55 Regular',
  'Alibaba PuHuiTi 3.0 65 Medium',
  'Alimama DongFangDaKai',
  'Alimama FangYuanTi VF',
  'Alimama ShuHeiTi',
  'DingTalk JinBuTi',
  '微软雅黑',
  '隶书',
  '黑体',
  '楷体',
  '宋体',
  '仿宋',
  'OPPO Sans Medium',
  'OPPO Sans',
  'Noto Sans',
  'Impact',
  'Times New Roman',
  'sans-serif',
  'Arial',
  'Gagalin',
  'Zfull-GB',
  'Microsoft YaHei',
  '5ka Sans Design',
  '5ka Sans Design Black',
  '5ka Sans Design SemiBold'
]

export const fontSizeList = [
  10,
  12,
  14,
  16,
  18,
  20,
  24,
  28,
  30,
  32,
  36,
  40,
  60,
  80,
  100,
  150,
  200,
  500
]


export const calcList = [
  '+',
  '-',
  '*',
  '/',
  '%'
]


export const QrCodeType = [
  'QR code',
  'Data Martrix'
]


export const BarCodeType = [
  'CODE128',
  'CODE39',
  'DataBar',
  'EAN-8',
  'EAN-13',
  'Interleaved 2 of 5',
  'PDF417',
  'UPC(A)'
]


export const roundingModeList = [
  {
    value: 1,
    label: i18n.t('lcd.Editor.Round Up')
  },
  {
    value: 2,
    label: i18n.t('lcd.Editor.Round Down')
  },
  {
    value: 3,
    label: i18n.t('lcd.Editor.Half Up')
  },
  {
    value: 4,
    label: i18n.t('lcd.Editor.Half Down')
  }
]

export const qrcodeList = [
  {
    id: 1,
    value: 'QR_CODE'
  },
  {
    id: 2,
    value: 'DATA_MATRIX'
  },
]

export const barcodeFormatList = [
  {
    id: 1,
    value: 'CODE_128'
  },
  {
    id: 2,
    value: 'CODE_39'
  },
  {
    id: 3,
    value: 'CODE_93'
  },
  {
    id: 4,
    value: 'EAN_8'
  },
  {
    id: 5,
    value: 'EAN_13'
  },
  {
    id: 6,
    value: 'CODABAR'
  },
]


export const textPositionType = [
  {
    value: 0,
    label: i18n.t('lcd.Editor.None Text')
  },
  {
    value: 1,
    label: i18n.t('lcd.Editor.Top')
  },
  {
    value: 2,
    label: i18n.t('lcd.Editor.Bottom')
  }
]

// 线条类型
export const lineTypeList = [
  {
    value: 1,
    label: i18n.t('lcd.Editor.Horizontal Line')
  },
  {
    value: 2,
    label: i18n.t('lcd.Editor.Vertical Line')
  },
  {
    value: 3,
    label: i18n.t('lcd.Editor.RightTop to LeftBottom')
  },
  {
    value: 4,
    label: i18n.t('lcd.Editor.LeftTop to RightBottom')
  },
  {
    value: 5,
    label: i18n.t('lcd.Editor.Double diagonal')
  },
]


// 黑白
export const color401 = [
  'rgba(0,0,0,1)',        // 黑
  'rgba(255,255,255,1)',  // 白
]
// 黑白红
export const color402 = [
  'rgba(0,0,0,1)',        // 黑
  'rgba(255,255,255,1)',  // 白
  'rgba(255,0,0,1)',      // 红
]
// 黑白黄
export const color403 = [
  'rgba(0,0,0,1)',        // 黑
  'rgba(255,255,255,1)',  // 白
  'rgba(255,255,0,1)',    // 黄
]
// 黑白红黄
export const color404 = [
  'rgba(0,0,0,1)',        // 黑
  'rgba(255,255,255,1)',  // 白
  'rgba(255,0,0,1)',      // 红
  'rgba(255,255,0,1)',    // 黄
]
// 黑白红黄蓝绿橙
export const color405 = [
  'rgba(0,0,0,1)',        // 黑
  'rgba(255,255,255,1)',  // 白
  'rgba(255,0,0,1)',      // 红
  'rgba(255,255,0,1)',    // 黄
  'rgba(0,0,255,1)',      // 蓝
  'rgba(0,255,0,1)',      // 绿
  'rgba(255,125,0,1)',    // 橙
]

export const colorList = [
  {
    id:1,
    color: 'rgba(0,0,0,1)',// 黑
    flag: [401,402,403,404,405],
  },
  {
    id:2,
    color: 'rgba(255,255,255,1)',  // 白
    flag: [401,402,403,404,405],
  },
  {
    id:3,
    color: 'rgba(255,0,0,1)',      // 红
    flag: [402,404,405],
  },
  {
    id:4,
    color: 'rgba(255,255,0,1)',    // 黄
    flag: [403,404,405],
  },
  {
    id:5,
    color: 'rgba(0,0,255,1)',      // 蓝
    flag: [405],
  },
  {
    id:6,
    color: 'rgba(0,255,0,1)',      // 绿
    flag: [405],
  },
  {
    id:7,
    color: 'rgba(255,125,0,1)',    // 橙
    flag: [405],
  },
]


// 时间格式formart - 日期
export const dateFormat = [
  {
    value: 1,
    label: 'YYYYMMDD',  // 年月日
  },
  {
    value: 2,
    label: 'MMDDYYYY',  // 月日年
  },
  {
    value: 3,
    label: 'DDMMYYYY',  // 日月年
  }
]

// 时间格式formart - 时间
export const timeFormat = [
  {
    value: 0,
    label: 'None',  // 不显示时分秒
  },
  {
    value: 1,
    label: '12H',  // 12小时制
  },
  {
    value: 2,
    label: '24H',  // 24小时制
  },
]